import {
  FoundItemResponse,
  ItemDTO
} from "src/component-lib/src/utils/api";

export const isExistingItem = (item: ItemDTO | FoundItemResponse): item is ItemDTO => {
  return (item as ItemDTO).dateFound !== undefined;
};
